import Vue from 'vue'
import App from '@/App.vue'
import { router } from '@/router'
import { store } from '@/store'
import '@/directives'

// element ui
import Element from 'element-ui'
import '@/style/element.scss'

import VueHtmlToPaper from 'vue-html-to-paper'

Vue.config.productionTip = false

const VueHtmlToPaperOptions = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css',
    process.env.BASE_URL + 'print.css'
  ]
}

Vue.use(Element)
Vue.use(VueHtmlToPaper, VueHtmlToPaperOptions)

export const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
